import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import _ from 'lodash';
import Options from '@/mixins/Options';

export default {
  mixins: [Options],
  methods: {
    ...mapActions({
      _setFilterParams: 'filters/setFilter',
      _getHomeData: 'home/getHomePageData',
      _getKeyData: 'digitalKeys/acquireData',
      _getGroupData: 'groups/acquireGroups',
      _getScreenData: 'screens/getAllScreensData',
      _getReportInstances: 'reports/acquireSessions',
      _getReportGroups: 'reports/acquireGroups',
      getDevices: 'maps/getDeviceLocations',
      _getRentalData: 'reconciliation/acquireRentalData',
      _getOneWayData: 'reconciliation/acquireOneWayData',
    }),
    apply: _.debounce(function () {
      // this._setActive(false);
      if (this.$route.name === 'Home') {
        this._getHomeData(this._client);
      } else if (this.$route.name === 'Keys') {
        this._getKeyData();
      } else if (this.$route.name === 'Groups') {
        this._getGroupData(this.options);
      } else if (this.$route.name === 'Screens') {
        this._getScreenData(this.options);
      } else if (this.$route.name === 'Devices') {
        this.getDevices(this._client);
      } else if (this.$route.name === 'Reports') {
        this._getReportInstances(this.options);
      } else if (this.$route.name === 'Reconciliation') {
        this._getRentalData(this._client);
        this._getOneWayData(this._client);
      }
    }, 500),
    changePage(direction) {
      if (direction === 'forward') {
        this.filterParams.page++;
      } else {
        this.filterParams.page--;
      }
    },
    clear() {
      let currentFilter = null;
      if (this.$route.name === 'Reconciliation') {
        currentFilter = this.filterParams[this.reconTabName];
      } else {
        currentFilter = this.filterParams;
      }
      const keys = Object.keys(currentFilter);
      keys.forEach((element) => {
        switch (element) {
          case 'filter':
            currentFilter[element] = {};
            break;
          case 'end_date':
            currentFilter[element] = this.$route.name === 'Home'
              || this.$route.name === 'Reports'
              || (this.$route.name === 'Reconciliation'
                && this.reconTabName === 'return')
              ? moment()
                .endOf('isoWeek')
                .format('YYYY-MM-DD')
              : undefined;
            break;
          case 'start_date':
            currentFilter[element] = this.$route.name === 'Home'
              || this.$route.name === 'Reports'
              || (this.$route.name === 'Reconciliation'
                && this.reconTabName === 'return')
              ? moment()
                .endOf('isoWeek')
                .format('YYYY-MM-DD')
              : undefined;
            break;
          case 'searchType':
            currentFilter[element] = undefined;
            break;
          case 'page':
            break;
          case 'tokens':
            break;
          case 'currentNextToken':
            break;
          case 'range':
            currentFilter[element] = this.$route.name === 'Home'
              || this.$route.name === 'Reports'
              || (this.$route.name === 'Reconciliation'
                && this.reconTabName === 'return')
              ? 'This Week'
              : undefined;
            break;
          default:
            currentFilter[element] = '';
        }
      });
      localStorage.setItem(
        `filters/${this.$route.name}`,
        JSON.stringify(this.filterParams),
      );
      // this._setActive(false);
    },
    openFilter() {
      this.filterParams.page = 1;
      this.filterParams.tokens = {
        1: null,
      };
      this._setFilters(true);
    },
    removeItem(item) {
      let currentFilter = null;
      if (this.$route.name === 'Reconciliation') {
        currentFilter = this.filterParams[this.reconTabName];
      } else {
        currentFilter = this.filterParams;
      }
      switch (item.name) {
        case 'filter':
          currentFilter[item.name] = {};
          break;
        case 'end_date':
          currentFilter[item.name] = this.$route.name === 'Home'
            ? moment()
              .endOf('isoWeek')
              .format('YYYY-MM-DD')
            : undefined;
          break;
        case 'start_date':
          currentFilter[item.name] = this.$route.name === 'Home'
            ? moment()
              .startOf('isoWeek')
              .format('YYYY-MM-DD')
            : undefined;
          break;
        case 'searchType':
          currentFilter[item.name] = undefined;
          break;
        case 'range':
          currentFilter[item.name] = this.$route.name === 'Home' ? 'This Week' : undefined;
          break;
        case 'page':
          break;
        default:
          currentFilter[item.name] = '';
      }
      localStorage.setItem(
        `filters/${this.$route.name}`,
        JSON.stringify(this.filterParams),
      );
      // this._setActive(false);
    },
    async setFilters() {
      let time;
      let startOfMonth;
      let endOfMonth;
      let startOfYear;
      let endOfYear;
      let startOfWeek;
      let endOfWeek;
      let switchRange = null;
      this.filterParams.searchPage = this.$route.name;
      if (
        this.$route.name === 'Reconciliation'
        && this.reconTabName === 'return'
      ) {
        switchRange = this.filterParams.return.range;
      } else {
        switchRange = this.filterParams.range;
      }
      switch (switchRange) {
        case 'Today':
          time = moment().format('YYYY-MM-DD');
          this.filterParams.start_date = time;
          this.filterParams.end_date = moment()
            .add(1, 'day')
            .format('YYYY-MM-DD');
          break;
        case 'Yesterday':
          time = moment()
            .subtract(1, 'days')
            .format('YYYY-MM-DD');
          this.filterParams.start_date = time;
          this.filterParams.end_date = moment(time)
            .add(1, 'day')
            .format('YYYY-MM-DD');
          break;
        case 'This Month':
          startOfMonth = moment()
            .startOf('month')
            .format('YYYY-MM-DD');
          endOfMonth = moment()
            .endOf('month')
            .format('YYYY-MM-DD');
          this.filterParams.start_date = startOfMonth;
          this.filterParams.end_date = endOfMonth;
          break;
        case 'This Year':
          startOfYear = moment()
            .startOf('year')
            .format('YYYY-MM-DD');
          endOfYear = moment()
            .endOf('year')
            .format('YYYY-MM-DD');
          this.filterParams.start_date = startOfYear;
          this.filterParams.end_date = endOfYear;
          break;
        case 'Last Week':
          startOfWeek = moment()
            .subtract(1, 'weeks')
            .startOf('isoWeek')
            .format('YYYY-MM-DD');
          endOfWeek = moment()
            .subtract(1, 'weeks')
            .endOf('isoWeek')
            .format('YYYY-MM-DD');
          this.filterParams.start_date = startOfWeek;
          this.filterParams.end_date = endOfWeek;
          break;
        case 'Last Month':
          startOfMonth = moment()
            .subtract(1, 'months')
            .startOf('month')
            .format('YYYY-MM-DD');
          endOfMonth = moment()
            .subtract(1, 'months')
            .endOf('month')
            .format('YYYY-MM-DD');
          this.filterParams.start_date = startOfMonth;
          this.filterParams.end_date = endOfMonth;
          break;
        case 'This Week':
          startOfWeek = moment()
            .startOf('isoWeek')
            .format('YYYY-MM-DD');
          endOfWeek = moment()
            .endOf('isoWeek')
            .format('YYYY-MM-DD');
          this.filterParams.start_date = startOfWeek;
          this.filterParams.end_date = endOfWeek;
          break;
        case 'Last Year':
          startOfYear = moment()
            .subtract(1, 'years')
            .startOf('year')
            .format('YYYY-MM-DD');
          endOfYear = moment()
            .subtract(1, 'years')
            .endOf('year')
            .format('YYYY-MM-DD');
          this.filterParams.start_date = startOfYear;
          this.filterParams.end_date = endOfYear;
          break;
        default:
          break;
      }
      if (this.$route.name === 'Reconciliation') {
        this.filterParams.return.start_date = this.filterParams.start_date;
        this.filterParams.return.end_date = this.filterParams.end_date;
      }
    },
  },
  watch: {
    _filterParams: {
      async handler() {
        await this.setFilters();
        localStorage.setItem(
          `filters/${this.$route.name}`,
          JSON.stringify(this.filterParams),
        );
        if (this._client.client_name && this._clientIsSet) {
          if (
            (this.$route.name === 'Home' || this.$route.name === 'Reports')
            && !this.filterParams.start_date
          ) {
            this.filterParams.range = 'This Week';
          }
          this.apply();
        }
      },
      deep: true,
    },
    _clientIsSet() {
      if (this._clientIsSet) {
        if (
          (this.$route.name === 'Home' || this.$route.name === 'Reports')
          && !this.filterParams.start_date
        ) {
          this.filterParams.range = 'This Week';
        }
        this.apply();
      }
    },
  },
  computed: {
    ...mapGetters({
      _filterParams: 'filters/getFilter',
      _client: 'account/getCurrentClient',
      _reconciliationTab: 'reconciliation/getTab',
      _clientIsSet: 'account/getClientIsSet',
    }),
    filterParams: {
      get() {
        return this._filterParams;
      },
      async set(val) {
        await this._setFilterParams(val);
      },
    },
    reconTabName() {
      if (this._reconciliationTab === 0) {
        return 'return';
      }
      return 'oneWay';
    },
  },
  mounted() {
    if (localStorage.getItem(`filters/${this.$route.name}`)) {
      this.filterParams = JSON.parse(
        localStorage.getItem(`filters/${this.$route.name}`),
      );
    } else if (this.$route.name === 'Reconciliation') {
      this.filterParams = {
        return: {
          page: 1,
          tokens: {
            1: null,
          },
        },
        oneWay: {
          page: 1,
          tokens: {
            1: null,
          },
        },
      };
    } else {
      this.filterParams = {
        page: 1,
        tokens: {
          1: null,
        },
      };
    }
  },
};
